import React, { useEffect, useState } from "react";
import RouteModal from "../../../../Component/BasicComponents/Modal/RouteModal";
import CustomInput from "../../../../Component/BasicComponents/CustomInput";
import ReusableDropdown from "../../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import { Btn } from "../../../../AbstractElements";
import {
  useAddBeat,
  useBeatById,
  useTerritoryByOrgUnitData,
  useTownByOrgUnitIDTerritoryIdData,
  useUpdateBeat,
} from "../hooks/useBeat";
import { toast } from "react-toastify";
import { Spinner } from "reactstrap";

type ProductCardProps = {
  setIsModalOpen?: any;
  isModalOpen?: any;
  toggleModal?: any;
  title?: any;
  checkAddEditStatus?: any;
  setCheckAddEditStatus?: any;
  OrgUnitData?: any;
  rowData?: any;
};
const BeatAddAndEditModal: React.FC<ProductCardProps> = ({
  rowData,
  OrgUnitData,
  setIsModalOpen,
  isModalOpen,
  title,
  checkAddEditStatus,
  setCheckAddEditStatus,
}) => {
  const [modalValues, setModalValues] = useState<any>({
    BeatName: "",
    BeatCode: "",
    BeatRemark: "",
    OrgUnitId: "",
    TerritoryId: "",
    Itownid: "",
  });

  const { data: BeatData, isLoading: isBeatLoading } = useBeatById({
    enable: !!rowData?.BeatId,
    id: rowData?.BeatId,
  });
  const { data: TerritoryData, isLoading: isTerritoryLoading } =
    useTerritoryByOrgUnitData({
      enable: !!modalValues?.OrgUnitId,
      OrgUnitId: modalValues?.OrgUnitId,
    });
  const { data: TownData, isLoading: isTownLoading } =
    useTownByOrgUnitIDTerritoryIdData({
      enable: modalValues?.OrgUnitId && modalValues?.TerritoryId ? true : false,
      params: {
        OrgUnitId: modalValues?.OrgUnitId,
        TerritoryId: modalValues?.TerritoryId,
      },
    });

  const [isDissable, setIsDissable] = useState(false);
  const { mutate } = useAddBeat();
  const { mutate: updateMutate } = useUpdateBeat();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!modalValues?.BeatName?.trim()) {
      toast.warn("Please enter Beat Name.");
      return;
    }
    if (!modalValues?.BeatCode?.trim()) {
      toast.warn("Please enter Beat Code.");
      return;
    }
    if (!modalValues?.OrgUnitId) {
      toast.warn("Please select Org Unit.");
      return;
    }
    if (!modalValues?.TerritoryId) {
      toast.warn("Please select Territory.");
      return;
    }
    if (!modalValues?.Itownid) {
      toast.warn("Please select Town.");
      return;
    }
    const body = {
      BeatName: modalValues?.BeatName,
      BeatCode: modalValues?.BeatCode,
      BeatRemark: modalValues?.BeatRemark,
      OrgUnitId: modalValues?.OrgUnitId,
      TerritoryId: modalValues?.TerritoryId,
      Itownid: modalValues?.Itownid,
    };

    if (checkAddEditStatus === "Add") {
      mutate(body, {
        onSuccess: () => {
          setIsModalOpen(false);
        },
      });
      setIsDissable(true);
      setModalValues({
        BeatName: "",
        BeatCode: "",
        BeatRemark: "",
        OrgUnitId: "",
        TerritoryId: "",
        Itownid: "",
      });
      setIsDissable(false);
    } else {
      updateMutate(
        { id: Number(rowData?.BeatId), body },
        {
          onSuccess: () => {
            setIsModalOpen(false);
          },
        }
      );
    }
  };
  useEffect(() => {
    //    console.log('rowDataaaaaa',rowData)
    if (checkAddEditStatus === "Edit" && BeatData?.data) {
      setModalValues((prevState: any) => ({
        ...prevState,
        BeatName: BeatData?.data?.BeatName,
        BeatCode: BeatData?.data?.BeatCode,
        BeatRemark: BeatData?.data?.BeatRemark,
        OrgUnitId: BeatData?.data?.OrgUnitId,
        TerritoryId: BeatData?.data?.TerritoryId,
        Itownid: BeatData?.data?.Itownid,
      }));
    }
  }, [checkAddEditStatus, BeatData]);
  const isLoading = isBeatLoading || isTerritoryLoading || isTownLoading;
  return (
    <RouteModal
      isOpen={isModalOpen}
      toggle={() => {
        setIsModalOpen(!isModalOpen);
        setModalValues((prevState: any) => ({
          ...prevState,
          BeatName: "",
          BeatCode: "",
          BeatRemark: "",
          OrgUnitId: "",
          TerritoryId: "",
          Itownid: "",
        }));
      }}
      title={title}
      // title="Add MTP"
      size="md"
      content={
        isLoading ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "60vh" }}
          >
            <Spinner
              color="primary"
              style={{ width: "3rem", height: "3rem" }}
            />
            {/* <span className="ms-3">Loading SGPI Brands...</span> */}
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="row mb-0">
              <div className="d-flex justify-content-start gap-2">
                <CustomInput
                  placeholder="Name"
                  disabled={false}
                  onChange={(e: any) => {
                    setModalValues((prevState: any) => ({
                      ...prevState,
                      BeatName: e.target.value,
                    }));
                  }}
                  value={modalValues?.BeatName}
                  required={true}
                  label="Name*"
                  style={{
                    border: "1px solid #EDEDED",
                    borderRadius: "4px",
                    padding: "10px",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                  }}
                />
                <CustomInput
                  placeholder="Remark"
                  disabled={false}
                  onChange={(e: any) => {
                    setModalValues((prevState: any) => ({
                      ...prevState,
                      BeatRemark: e.target.value,
                    }));
                  }}
                  value={modalValues?.BeatRemark}
                  // required={true}
                  label="Remark"
                  style={{
                    border: "1px solid #EDEDED",
                    borderRadius: "4px",
                    padding: "10px",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                  }}
                />
              </div>

              <div className="d-flex justify-content-start gap-2">
                <CustomInput
                  placeholder="Code"
                  disabled={false}
                  onChange={(e: any) => {
                    setModalValues((prevState: any) => ({
                      ...prevState,
                      BeatCode: e.target.value,
                    }));
                  }}
                  value={modalValues?.BeatCode}
                  required={true}
                  label="Code*"
                  style={{
                    border: "1px solid #EDEDED",
                    borderRadius: "4px",
                    padding: "10px",
                    fontSize: "14px",
                    backgroundColor: "#fff",
                  }}
                />

                <ReusableDropdown
                  options={OrgUnitData || []}
                  value={modalValues?.OrgUnitId}
                  onChange={(value: any) => {
                    setModalValues((prevState: any) => ({
                      ...prevState,
                      OrgUnitId: value,
                      TerritoryId: "",
                      Itownid: "",
                    }));
                  }}
                  DropdownHeading="Org Unit*"
                />
              </div>
              <div className="d-flex justify-content-start gap-2">
                <ReusableDropdown
                  options={TerritoryData?.data || []}
                  value={modalValues?.TerritoryId}
                  onChange={(value: any) => {
                    setModalValues((prevState: any) => ({
                      ...prevState,
                      TerritoryId: value,
                      Itownid: "",
                    }));
                  }}
                  DropdownHeading="Territory*"
                />
                <ReusableDropdown
                  options={TownData?.data || []}
                  value={modalValues?.Itownid}
                  onChange={(value: any) => {
                    setModalValues((prevState: any) => ({
                      ...prevState,
                      Itownid: value,
                    }));
                  }}
                  DropdownHeading="Town*"
                />
              </div>
              <div style={{ height: 20 }} />
              <div className="d-flex justify-content-start gap-2">
                <Btn
                  disabled={isDissable}
                  style={{ backgroundColor: "#43B9B2", color: "white" }}
                  type="submit"
                >
                  {checkAddEditStatus === "Add" ? "Submit" : "Update"}
                </Btn>
                <Btn
                  style={{
                    backgroundColor: "#F9FAFC",
                    color: "#000",
                    border: "1px solid #E0E0E0",
                  }}
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                >
                  Cancel
                </Btn>
              </div>
            </div>
          </form>
        )
      }
    />
  );
};

export default BeatAddAndEditModal;
